import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';

import { ConfiguracaoEmpresaInput, type ConfiguracaoEmpresaInputType } from '@shared/dto';

import { Button } from '../../../components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../../../components/ui/form';
import { Input } from '../../../components/ui/input';
import { useAuth } from '../../../hooks/use-auth';

export function GeralTab() {
  const { usuario, atualizarNomeEmpresa } = useAuth();
  const form = useForm<ConfiguracaoEmpresaInputType>({
    resolver: zodResolver(ConfiguracaoEmpresaInput),
    defaultValues: { nomeEmpresa: usuario?.nomeEmpresa ?? 'KFlow' },
  });

  async function onSubmit({ nomeEmpresa }: ConfiguracaoEmpresaInputType) {
    await atualizarNomeEmpresa(nomeEmpresa);
    toast.success('Nome da empresa atualizado.');
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="max-w-lg space-y-4 rounded-lg border p-4"
      >
        <FormField
          control={form.control}
          name="nomeEmpresa"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Nome da empresa</FormLabel>
              <FormControl>
                <Input {...field} maxLength={80} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <Button type="submit" disabled={form.formState.isSubmitting}>
          {form.formState.isSubmitting ? 'Salvando...' : 'Salvar'}
        </Button>
      </form>
    </Form>
  );
}
